import React, { useState, useEffect } from 'react'
import './RutaPagosContainer.css'
import MaterialTable from 'material-table'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
} from '@material-ui/core'
import { RemoveCircle, Visibility, CheckCircle, Warning, Close } from '@material-ui/icons'

const RutaPagosContainer = () => {
  const [pagos, setPagos] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false)
  const [openDetailDialog, setOpenDetailDialog] = useState(false)
  const [selectedVendor, setSelectedVendor] = useState(null)
  const [totalPago, setTotalPago] = useState(0)
  const [fechaUltimoPago, setFechaUltimoPago] = useState('')
  const [periodoPago, setPeriodoPago] = useState('')

  // Simulated data - replace with actual API call
  const getPagosData = async () => {
    setIsLoading(true)
    // Simulated API response
    const response = {
      pagos: [
        {
          cc: '100942301',
          nombre: 'Felipe Auteco',
          recompensa_actual: 100000,
          estado: 'activo',
          historial: [
            {
              id_producto: 'c5aad7b21f98d',
              repuesto: 'Llanta',
              categoria: 'cat 1',
              sub_categoria: 'scat1',
              precio: 300000,
              punto_venta: 'Bogota DC',
              fecha: '4 oct 2024 - 11:00am',
              recompensa: 3000,
              pago: 'Por pagar'
            },
            {
              id_producto: 'h2aad7b21f98d',
              repuesto: 'Carcasa',
              categoria: 'cat 2',
              sub_categoria: 'scat2',
              precio: 80000,
              punto_venta: 'Bogota DC',
              fecha: '5 oct 2024 - 12:00pm',
              recompensa: 800,
              pago: '#350'
            },
          ]
        },
        {
          cc: '100942302',
          nombre: 'Maria Auteco',
          recompensa_actual: 150000,
          estado: 'pendiente',
          historial: [
            {
              id_producto: 'd5aad7b21f98d',
              repuesto: 'Faro',
              categoria: 'cat 3',
              sub_categoria: 'scat3',
              precio: 50000,
              punto_venta: 'Medellin',
              fecha: '6 oct 2024 - 01:00pm',
              recompensa: 500,
              pago: 'Por pagar'
            },
            {
              id_producto: 'e2aad7b21f98d',
              repuesto: 'Espejo',
              categoria: 'cat 4',
              sub_categoria: 'scat4',
              precio: 20000,
              punto_venta: 'Medellin',
              fecha: '7 oct 2024 - 02:00pm',
              recompensa: 200,
              pago: '#351'
            },
          ]
        },
        {
          cc: '100942303',
          nombre: 'Juan Auteco',
          recompensa_actual: 200000,
          estado: 'activo',
          historial: [
            {
              id_producto: 'f5aad7b21f98d',
              repuesto: 'Batería',
              categoria: 'cat 5',
              sub_categoria: 'scat5',
              precio: 150000,
              punto_venta: 'Cali',
              fecha: '8 oct 2024 - 03:00pm',
              recompensa: 1500,
              pago: 'Por pagar'
            },
            {
              id_producto: 'g2aad7b21f98d',
              repuesto: 'Manubrio',
              categoria: 'cat 6',
              sub_categoria: 'scat6',
              precio: 60000,
              punto_venta: 'Cali',
              fecha: '9 oct 2024 - 04:00pm',
              recompensa: 600,
              pago: '#352'
            },
          ]
        }
        // Add more vendors as needed
      ],
      total_pendiente: 24000000,
      fecha_ultimo_pago: '21 de octubre',
      periodo_pago: '21 oct - 28 oct'
    }
    
    setPagos(response.pagos)
    setTotalPago(response.total_pendiente)
    setFechaUltimoPago(response.fecha_ultimo_pago)
    setPeriodoPago(response.periodo_pago)
    setIsLoading(false)
  }

  useEffect(() => {
    getPagosData()
  }, [])

  const handleConfirmarPago = () => {
    setOpenConfirmDialog(false)
  }

  const handleViewDetail = (vendor) => {
    setSelectedVendor(vendor)
    setOpenDetailDialog(true)
  }

  const renderEstadoIcon = (estado) => {
    switch (estado) {
      case 'activo':
        return <CheckCircle style={{ color: 'green' }} />
      case 'pendiente':
        return <Warning style={{ color: 'orange' }} />
      default:
        return null
    }
  }

  const DetailDialog = () => (
    <Dialog
      open={openDetailDialog}
      onClose={() => setOpenDetailDialog(false)}
      maxWidth="lg"
      fullWidth
    >
      <DialogTitle>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h6">
            Historial Recompensas por Ventas - {selectedVendor?.nombre}
          </Typography>
          <IconButton onClick={() => setOpenDetailDialog(false)}>
            <Close />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent>
        <div className="detail-header">
          <Typography>
            Total recompensas pendientes: {selectedVendor?.recompensa_actual.toLocaleString()}
          </Typography>
          <Typography>
            Fecha último pago: {fechaUltimoPago}
          </Typography>
        </div>
        
        <MaterialTable
          title=""
          options={{
            pageSize: 10,
            pageSizeOptions: [10, 20, 50],
            headerStyle: {
              backgroundColor: '#F6F6F6',
              color: '#161615',
              fontSize: '14px',
              fontWeight: 700,
            },
            search: true,
          }}
          columns={[
            { title: 'Id Producto', field: 'id_producto' },
            { title: 'Repuesto', field: 'repuesto' },
            { title: 'Categoria', field: 'categoria' },
            { title: 'Sub Categoria', field: 'sub_categoria' },
            { 
              title: 'Precio', 
              field: 'precio',
              render: (rowData) => rowData.precio.toLocaleString()
            },
            { title: 'Punto de Venta', field: 'punto_venta' },
            { title: 'Fecha', field: 'fecha' },
            { 
              title: 'Recompensa', 
              field: 'recompensa',
              render: (rowData) => rowData.recompensa.toLocaleString()
            },
            { title: 'Pago', field: 'pago' },
          ]}
          data={selectedVendor?.historial || []}
        />
      </DialogContent>
    </Dialog>
  )

  return (
    <div className="pagos-container">
      <div className="header-info">
        <Typography variant="h5">
          Recompensas - Pagos pendientes a vendedores
        </Typography>
        <div className="summary-info">
          <Typography>
            Total recompensas pendientes: {totalPago.toLocaleString()}
          </Typography>
          <Typography>
            Fecha último pago: {fechaUltimoPago}
          </Typography>
        </div>
      </div>

      <div className={`table-container ${isLoading ? 'loading' : ''}`}>
        <MaterialTable
          title=""
          options={{
            pageSize: 10,
            pageSizeOptions: [10, 20, 50],
            headerStyle: {
              backgroundColor: '#F6F6F6',
              color: '#161615',
              fontSize: '14px',
              fontWeight: 700,
            },
            actionsColumnIndex: -1,
          }}
          columns={[
            { title: 'CC', field: 'cc' },
            { title: 'Nombre', field: 'nombre' },
            { 
              title: 'Recompensa Actual',
              field: 'recompensa_actual',
              render: (rowData) => rowData.recompensa_actual.toLocaleString()
            },
            {
              title: 'Ver',
              render: (rowData) => (
                <IconButton onClick={() => handleViewDetail(rowData)}>
                  <Visibility style={{ color: '#3f51b5' }} />
                </IconButton>
              ),
              width: 70
            },
            {
              title: 'Bloquear',
              render: () => (
                <IconButton>
                  <RemoveCircle style={{ color: '#f44336' }} />
                </IconButton>
              ),
              width: 70
            },
            {
              title: 'Estado',
              field: 'estado',
              render: (rowData) => renderEstadoIcon(rowData.estado)
            }
          ]}
          data={pagos}
        />

        <div className="actions-container">
          <Button
            variant="outlined"
            color="primary"
            onClick={() => setOpenConfirmDialog(true)}
          >
            Realizar pagos
          </Button>
        </div>
      </div>

      <Dialog
        open={openConfirmDialog}
        onClose={() => setOpenConfirmDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Confirmar Pago</DialogTitle>
        <DialogContent>
          <div className="confirm-dialog-content">
            <Warning style={{ color: '#ffc107', fontSize: 48 }} />
            <Typography variant="body1" style={{ marginTop: 20 }}>
              Total a Desembolsar: {totalPago.toLocaleString()}
            </Typography>
            <Typography variant="body1">
              Periodo de pago: {periodoPago}
            </Typography>
            <Typography variant="body1">
              Fecha último pago: {fechaUltimoPago}
            </Typography>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConfirmDialog(false)} color="default">
            Cancelar
          </Button>
          <Button onClick={handleConfirmarPago} color="primary">
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>

      {openDetailDialog && <DetailDialog />}
    </div>
  )
}

export default RutaPagosContainer